// extracted by mini-css-extract-plugin
module.exports = {"map":"index-module--map--1Z8DI","form":"index-module--form--3po0M"};